/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewtotalpaidlabelen6Inputs */

const en_letterpreviewtotalpaidlabelen6 = /** @type {(inputs: Letterpreviewtotalpaidlabelen6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total paid to date:`)
};

const pt_letterpreviewtotalpaidlabelen6 = /** @type {(inputs: Letterpreviewtotalpaidlabelen6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total paid to date:`)
};

/**
* | output |
* | --- |
* | "Total paid to date:" |
*
* @param {Letterpreviewtotalpaidlabelen6Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewtotalpaidlabelen6 = /** @type {((inputs?: Letterpreviewtotalpaidlabelen6Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewtotalpaidlabelen6Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewtotalpaidlabelen6(inputs)
	return pt_letterpreviewtotalpaidlabelen6(inputs)
});
export { letterpreviewtotalpaidlabelen6 as "letterPreviewTotalPaidLabelEN" }